import React from "react";
import moment from "moment";
import BootstrapTable from "react-bootstrap-table-next";
import { toFloat } from "validator";
import { useTranslation } from "react-i18next";
import ToolkitProvider from "react-bootstrap-table2-toolkit";
import "react-bootstrap-table-next/dist/react-bootstrap-table2.min.css";

const EscrowPaymentsItemsTable = ({ tableData, defaultSorted }) => {
  const { t } = useTranslation();

  const dateFormatter = (cell, row) => {
    return (
      moment(cell).format('YYYY-MM-DD')
    );
  };

  const amountFormatter = (cell, row) => (
      <b>{toFloat(cell).toFixed(0)} €</b>
  );

  const columns = [
    {
      dataField: "payment_id",
      text: t("escrowWallet.view.escrowPaymentBreakdown.table.column.paymentId"),
      sort: false,
      headerStyle: () => ({ width: "120px" }),
    },
    {
      dataField: "track_name",
      text: t("escrowWallet.view.escrowPaymentBreakdown.table.column.trackName"),
      sort: false,
      headerStyle: () => ({ width: "120px" })
    },
    {
      dataField: "amount",
      text: t("escrowWallet.view.escrowPaymentBreakdown.table.column.amount"),
      formatter: amountFormatter,
      csvFormatter: amountFormatter,
      sort: false,
      headerStyle: () => ({ width: "120px" })
    },
    {
      dataField: "created",
      text: t("escrowWallet.view.escrowPaymentBreakdown.table.column.paymentDate"),
      formatter: dateFormatter,
      csvFormatter: dateFormatter,
      sort: true,
      headerStyle: () => ({ width: "120px" })
    },
    {
      dataField: "track_name",
      sort: false,
      csvExport: false,
      hidden: true,
    }
  ];

  return (
    <ToolkitProvider
      keyField="id"
      data={tableData}
      columns={columns}
      search={{
        searchFormatted: true
      }}
      exportCSV={{ fileName: "escrow-payments-items.csv" }}
    >
      {props => (
        <div>
          <BootstrapTable
            {...props.baseProps}
            bordered={false}
            remote={{ sort: true }}
            defaultSorted={defaultSorted}
          />
        </div>
      )}
    </ToolkitProvider>
  );
};

export default EscrowPaymentsItemsTable;